export default {
    init: (isPC) => {
        console.log(isPC);
        if (isPC === 0) {
            // Mobile

            _anchor();
            // 菜单状态控制
            $('.navbar-toggle img').click(function () {
                $('.close,.normal').toggle();
                $('.menu-mobile').toggle('active');
            });
        } else {
            // PC 暂无

        }
    },

}

// 锚点跳转
function _anchor() {
    $('a[href*=\\#],area[href*=\\#]').click(function () {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            let $target = $(this.hash);
            console.log($target)
            $target = $target.length && $target || $('[name=' + this.hash.slice(1) + ']');
            $('.close,.normal').toggle();
            $('.menu-mobile').toggle('active');
            if ($target.length) {
                let targetOffset = $target.offset().top;
                console.log(targetOffset)
                $('html,body').animate({
                    scrollTop: targetOffset - 80
                }, 1000);
                return false;
            }
        }
    });
}



// WEBPACK FOOTER //
// ./src/pages/index/menu.js